import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import { initSentry } from './sentry.js'
import { SentryErrorBoundary } from './ErrorBoundary.jsx'
import RestaurantDashboard from './restaurant-dashboard.jsx'

// Initialize Sentry before rendering
initSentry('restaurant-dashboard')

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <SentryErrorBoundary>
      <RestaurantDashboard />
    </SentryErrorBoundary>
  </React.StrictMode>,
)
